import React from 'react';
import styled from 'styled-components';

import { ExperienceNps } from 'modules/nps/features/ExperienceNps';

import { Content } from '../components/layout/Content';
import { Sidebar } from '../components/layout/Sidebar';

const IndexPageContainer = styled.div`
  display: flex;
  height: 100vh;
`;

export const IndexPage = () => {
  return (
    <IndexPageContainer>
      <ExperienceNps />
      <Sidebar />
      <Content />
    </IndexPageContainer>
  );
};
